// Typisierte Aufrufe gegen die Auth-Endpunkte des Backends.

import { API_BASE, ApiError, api } from "../lib/api.js";
import type { StoredAuth } from "./storage.js";

export interface DemoUser {
  id: string;
  email: string;
  displayName: string;
}

export interface DemoUsersResponse {
  users: DemoUser[];
}

export interface LoginResponse {
  token: string;
  user: StoredAuth["user"];
}

export interface MeResponse {
  user: StoredAuth["user"];
}

export const authApi = {
  listDemoUsers: () => api.get<DemoUsersResponse>("/auth/demo/users"),
  /** Provisionierte User aus der DB — Quelle fuer die Mitglied-hinzufuegen-Auswahl. */
  listUsers: () => api.get<DemoUsersResponse>("/api/users"),
  demoLogin: (userId: string) => api.post<LoginResponse>("/auth/demo/login", { userId }),
  me: () => api.get<MeResponse>("/api/me"),
  /**
   * /me mit explizitem Token — fuer den Entra-Bootstrap, bevor der Token im Storage liegt.
   * (Der normale api-Wrapper liest den Token aus dem Storage; hier kennen wir ihn frisch
   * aus dem URL-Fragment bzw. von MSAL und wollen ihn erst nach erfolgreicher /me schreiben.)
   */
  meWithToken: async (token: string): Promise<MeResponse> => {
    const res = await fetch(`${API_BASE}/api/me`, {
      headers: { Accept: "application/json", Authorization: `Bearer ${token}` },
    });
    if (!res.ok) throw new ApiError("me failed", res.status);
    return (await res.json()) as MeResponse;
  },
};
